export enum DialogId
{
  NONE,
  CONTINUE_DIALOG,
  PAUSE_DIALOG,
  CALENDAR_DIALOG,
  AVATAR_SELECTION_DIALOG,
  SAVE_DIALOG,
  ACCOUNT_PROGRESS_SAVED_DIALOG,
  EXIT_FROM_GAME_ACCOUNT_DIALOG,
  DISCONNECT_ACCOUNT_NOTIFICATION_DIALOG,
  DISCONNECT_ACCOUNT_DIALOG,
  CONNECT_ACCOUNT_DIALOG,
  TWO_ACCOUNTS_DIALOG,
  AUTH_MESSAGE_DIALOG,
  FAILED_DISCONNECT_SOCIAL_MEDIA_DIALOG,
  DELETE_ACCOUNT_DIALOG,
  DELETE_ACCOUNT_NOTIFICATION_DIALOG,
  RATE_GAME_DIALOG,
  GO_STORE_DIALOG,
  UPDATE_REQUIRED_DIALOG,
  CONNECTION_FAILED_DIALOG,
  SERVER_CHANGED_DIALOG,
  REMOVE_ADS_DIALOG,
  NO_LEVELS_DIALOG,
  DAILY_CHALLENGE_COMPLETED_DIALOG,
  TOWER_FAIL_DIALOG,
}
